import React from 'react';
import { Container, Spinner } from './ActivityIndicator.styles';

export interface ActivityIndicatorProps {
  size?: number;
  visible?: boolean;
}

const ActivityIndicator: React.FC<ActivityIndicatorProps> = ({
  size = 24,
  visible = true
}) => {
  if (!visible) return null;

  return (
    <Container>
      <Spinner $size={size} />
    </Container>
  );
};

export default ActivityIndicator;
